<template>
  <div>
    <p class="font-medium mb-2">Chapter Name</p>

    <el-input
      placeholder="Enter Topic Name"
      v-model="updateObject.chaptername"
      v-if="updateObject.update == true"
    ></el-input>
    <el-input placeholder="Enter Topic Name" v-model="topic" v-else></el-input>

    <div class="mt-2" v-if="updateObject.update == true">
      <el-button
        class="butto-chapter"
        @click="handleUpdateChapter(updateObject.chaptername)"
        >Update Chapter</el-button
      >
    </div>
    <div class="mt-2" v-else>
      <el-button class="butto-chapter" @click="handleaddchapter(topic)"
        >Add Chapter</el-button
      >
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      topic: "",
    };
  },
  props: {
    updateObject: Object,
    handleaddchapter: Function,
    handleUpdateChapter: Function,
  },
};
</script>

<style>
.butto-chapter {
  background-color: #5a5a5a;
  color: #fff;
}
</style>
